import { render, staticRenderFns } from "./shop-details.vue?vue&type=template&id=da10430a&scoped=true&"
import script from "./shop-details.vue?vue&type=script&lang=js&"
export * from "./shop-details.vue?vue&type=script&lang=js&"
import style0 from "./shop-details.vue?vue&type=style&index=0&id=da10430a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10430a",
  null
  
)

export default component.exports